import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "bg-white rounded-[20px] px-10 py-6" }
const _hoisted_2 = { class: "text-[40px] leading-100p font-medium text-left text-brown mb-10" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-10 md:pb-10" }
const _hoisted_4 = { class: "flex flex-col items-start" }
const _hoisted_5 = { class: "label-styles" }
const _hoisted_6 = { class: "flex flex-col items-start" }
const _hoisted_7 = { class: "label-styles" }
const _hoisted_8 = { class: "flex flex-col items-start" }
const _hoisted_9 = { class: "label-styles" }
const _hoisted_10 = { class: "flex flex-col items-start" }
const _hoisted_11 = {
  for: "sex",
  class: "label-styles"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "xl:border-t border-ternary flex items-center justify-center pt-6" }

import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import DatePicker from "@/components/inputs/DatePicker.vue";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { formatLocalDate } from "@/utils/date";
import GooglePlaceAutocompleteInput from "@/components/inputs/GooglePlaceAutocompleteInput.vue";
import { useGoogleAutocomplete } from "@/utils/useGoogleAutocomplete";
import { BaziPredictionRequest } from "@/types/calculators";
import { PlaceSelectedPayload } from "@/types/google-places";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaziPredictionForm',
  props: {
    loading: { type: Boolean }
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const { t } = useI18n();
const { normalizeGoogleTimeZone } = useGoogleAutocomplete("ru");

const birthDate = ref<Date | null>(null);
const birthTime = ref<string>("");
const gender = ref<string>("");
const longitude = ref<number | null>(null);
const timeZone = ref<string | null>(null);

const isValidInput = computed(() => {
  return (
    birthDate.value !== null &&
    birthTime.value.length > 0 &&
    longitude.value !== null &&
    timeZone.value !== null &&
    gender.value.length > 0
  );
});

const sexDropdownOptions = [
  { label: "calculators.bazi.labels.male", value: "1" },
  { label: "calculators.bazi.labels.female", value: "0" },
];

function handlePlaceSelected(payload: PlaceSelectedPayload) {
  longitude.value = payload.location.lng();
  timeZone.value = normalizeGoogleTimeZone(payload.timeZone);
}

function onSubmit() {
  if (isValidInput.value) {
    emit("submit", {
      date: formatLocalDate(birthDate.value as Date),
      time: birthTime.value,
      gender: gender.value,
      longitude: longitude.value as number,
      timezone: timeZone.value as string,
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(t)("calculators.bazi.title")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("calculators.bazi.labels.birthday")), 1),
        _createVNode(DatePicker, {
          id: "birthday",
          onDateSelected: _cache[0] || (_cache[0] = (newDate) => (birthDate.value = newDate))
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("calculators.bazi.labels.birthtime")), 1),
        _withDirectives(_createElementVNode("input", {
          id: "birthtime",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((birthTime).value = $event)),
          type: "time",
          class: "border border-divider pl-4 pr-[6px] w-full h-[52px] bg-secondary rounded-[14px] sf-pro font-normal text-base text-muted"
        }, null, 512), [
          [_vModelText, birthTime.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)("calculators.bazi.labels.place")), 1),
        _createVNode(GooglePlaceAutocompleteInput, { onPlaceSelected: handlePlaceSelected })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)("calculators.bazi.labels.sex")), 1),
        _withDirectives(_createElementVNode("select", {
          id: "sex",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((gender).value = $event)),
          class: "border border-divider pl-4 pr-4 w-full h-[52px] bg-secondary rounded-[14px] sf-pro font-normal text-base text-muted cursor-pointer"
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sexDropdownOptions, (item) => {
            return _createElementVNode("option", {
              key: item.value,
              value: item.value
            }, _toDisplayString(_unref(t)(item.label)), 9, _hoisted_12)
          }), 64))
        ], 512), [
          [_vModelSelect, gender.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(GradientButton, {
        class: "w-[191px] h-[56px]",
        "bg-color": "bg-brown-gradient",
        "hover-bg-color": "bg-orange-gradient",
        text: _unref(t)('buttons.calculate'),
        onClick: onSubmit,
        "is-loading": __props.loading,
        "is-disabled": !isValidInput.value
      }, null, 8, ["text", "is-loading", "is-disabled"])
    ])
  ]))
}
}

})